import { useQuery } from "react-query";
import axios from "infra/http";
import { OperacaoEnum } from "core/resources/enums/conta";
import { ContaTotais, ContaFiltroType } from "../typings";

function useDashboardConta(
  operacao: OperacaoEnum | null,
  params: Partial<ContaFiltroType>
) {
  return useQuery(
    [`/v1/dashboards/financeiro/conta/totais`, operacao, params],
    async () => {
      const { data } = await axios.get<ContaTotais>(
        `/v1/dashboards/financeiro/conta/totais`,
        {
          params: {
            ...params,
            operacao,
            atraso:
              params.atraso === true
                ? "1"
                : params.atraso === false
                ? "0"
                : undefined,
          },
        }
      );

      return data;
    },
    {
      enabled: !!operacao,
    }
  );
}

export default useDashboardConta;
